import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme-switcher"
export default class extends Controller {
  static targets = [ "input"];

  connect() {
  //find and set the current theme from the local storage
  //if the theme is set to auto, set the theme to the system theme
  if (localStorage.getItem('theme') === 'dark') {
    document.documentElement.setAttribute('data-bs-theme', 'dark');
  } else if (localStorage.getItem('theme') === 'auto') {
    document.documentElement.setAttribute(
      'data-bs-theme',
      window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );
  }
  };

  toogle() {
    this.element.classList.toggle("active");

    if (this.inputTarget.checked) {
      // console.log("Swtiching themen to: dark");
      document.documentElement.setAttribute('data-bs-theme', 'dark');
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.setAttribute('data-bs-theme', 'light');
      localStorage.setItem('theme', 'light')
    }

  };

}
